import React from 'react'

const cleanPercentage = (percentage: number) => {
    const isNegativeOrNaN = !Number.isFinite(+percentage) || percentage < 0; // we can set non-numbers to 0 here
    const isTooHigh = percentage > 100;
    return isNegativeOrNaN ? 0 : isTooHigh ? 100 : +percentage;
};

interface CircleProps {
    color: string
    percentage?: number
}

const Circle = ({color: color, percentage = 0}: CircleProps) => {
    const r = 22;
    const circ = 2 * Math.PI * r;
    const strokePct = ((100 - percentage) * circ) / 100;
    return (
        <circle
            r={r}
            cx={44}
            cy={44}
            fill="transparent"
            stroke={strokePct !== circ ? color : ""}
            strokeWidth={"3px"}
            strokeDasharray={circ}
            strokeDashoffset={percentage ? strokePct : 0}
        ></circle>
    );
};

interface ProgressBarProps {
    percentage: number
    color: string
}

export const ProgressBar = ({percentage, color}: ProgressBarProps) => {
    const pct = cleanPercentage(percentage);
    return (
        <svg width={88} height={88}>
            <g transform={`rotate(-90 ${"44 44"})`}>
                <Circle color="lightgrey"/>
                <Circle color={color} percentage={pct}/>
            </g>
        </svg>
    );
};